import {
    // apiRequest,
    riwayatjabatanCreate,
    masterPosition,
    masterEchelon,
    masterPositionStatus,
    masterWorkUnit,
    masterSignatoryOfficial
} from "../../../../../services/adapters/kepegawaian/riwayatjabatanService"
import {
    apiRequest,
    riwayatPangkatDetail,
    masterRank,
    masterRankType,
    createRiwayatPangkat
} from "../../../../../services/adapters/kepegawaian/riwayatPangkatService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", createRiwayatPangkat, {
            body: query
        }, true)
    }

    fetchRank = async (query) => {
        return await apiRequest("get", masterRank, {
            params: query
        }, true)
    }
    fetchRankType = async (query) => {
        return await apiRequest("get", masterRankType, {
            params: query
        }, true)
    }
    
    fetchPosition = async (query) => {
        return await apiRequest("get", masterPosition, {
            params: query
        }, true)
    }

    fetchEselon = async (query) => {
        return await apiRequest("get", masterEchelon, {
            params: query
        }, true)
    }

    fetchPositionStatus = async (query) => {
        return await apiRequest("get", masterPositionStatus, {
            params: query
        }, true)
    }

    fetchWorkUnit = async (query) => {
        return await apiRequest("get", masterWorkUnit, {
            params: query
        }, true)
    }

    fetchSignatoryOfficial = async (query) => {
        return await apiRequest("get", masterSignatoryOfficial, {
            params: query
        }, true)
    }

}

export default CreateRepository